import { addOverlayTile } from "../../map/render-layers/downloader";
import isNil from 'lodash/isNil'
// import './index.scss'
import { huntPlannerActiveLayerDetails } from "../../../action/huntplanner-curentLayerdetails-action";
import { store } from '../../../lib/store'
import { huntPlannerActiveLayerPayload } from "../../../action/huntplanner-activeLayerPayload";
import { startMapLoading, stopMapLoading } from "../../../action/huntplanner-map-loader";
import { zoomEVentStore } from "../../../action/huntplanner-zoomevent";
import { waitForGoogleMaps } from "../../map/maploader/maploader";

let ImageMapType;

waitForGoogleMaps(() => {
    ImageMapType = class extends google.maps.MVCObject {
        constructor(props) {
            super(props)
            Object.assign(this, props)
        }
    }
})
// class ImageMapType extends google.maps.MVCObject {
//     constructor(props) {
//         super(props)
//         Object.assign(this, props)
//     }
// }

export function tileToLon(coord, zoom, tileSize) {
    const scale = tileSize.width / 256

    const lon = (scale * coord / Math.pow(2.0, zoom)) * 360.0 - 180
    return lon
}

export function tileToLat(coord, zoom, tileSize) {
    //height
    const scale = 256 / tileSize.height
    let n = Math.PI - (2.0 * Math.PI * coord) / (scale * Math.pow(2.0, zoom))
    const lat = Math.atan(Math.sinh(n)) * (180 / Math.PI)
    return lat
}

function getMapBoundingBox(map) {
    const bounds = map.getBounds();
    const northEast = bounds.getNorthEast();
    const southWest = bounds.getSouthWest();
    if (bounds) {
        const boundingBox = {
            north: northEast.lat(),
            east: northEast.lng(),
            south: southWest.lat(),
            west: southWest.lng(),
        };
        return boundingBox
    }
}

export function degrees2meters(lon, lat) {
    let xm = (lon * 20037508.34) / 180
    let ym = Math.log(Math.tan(((90 + lat) * Math.PI) / 360)) / (Math.PI / 180)
    ym = (ym * 20037508.34) / 180

    return { xm, ym }
}

let isRenderingTiles = false;
let zoomEVent = null
let currentOverlay = null; // Global reference to store the latest overlay
let zoomEvent = null

export function multiTileHuntLayers(mapObj, mapObjVal, { mapInstance, filters }, tile, layerApi = false, params, layerData = '', callback) {
    let overlay;
    store.dispatch(huntPlannerActiveLayerDetails({
        id: layerData ? layerData.layerId : 'no id',
        name: layerData ? layerData.stateAbbr : 'no name',
    }));

    if (!layerData.layerId) {
        removeLayers(mapInstance)
    }

    store.dispatch(huntPlannerActiveLayerPayload({
        mapObj: mapObj,
        mapObjVal: mapObjVal,
        filter: { mapInstance, filters },
        tile: tile,
        layerApi: layerApi,
        params: params,
        layerData: layerData,
        callback: callback,
        id: layerData?.layerId
    }));

    function createOverlay() {
        store.dispatch(startMapLoading());

        if (currentOverlay) {
            // mapInstance.overlayMapTypes.removeAt(mapInstance.overlayMapTypes.getArray().indexOf(currentOverlay));
            currentOverlay = null;
        }
        // class ImageMapType extends google.maps.MVCObject {
        //     constructor(props) {
        //         super(props)
        //         Object.assign(this, props)
        //     }
        // }
        overlay = new ImageMapType({
            getTile: function (coord, zoom, doc) {
                let units = [];
                units = units.join(',');
                let { x, y } = coord;
                let center = mapInstance.getCenter();
                let minLat = tileToLon(x, zoom, this.tileSize);
                let maxLat = tileToLon(x + 1, zoom, this.tileSize);
                let minLon = tileToLat(y + 1, zoom, this.tileSize);
                let maxLon = tileToLat(y, zoom, this.tileSize);
                let min = degrees2meters(minLat, minLon);
                let minX = min.xm;
                let minY = min.ym;
                let max = degrees2meters(maxLat, maxLon);
                let maxX = max.xm;
                let maxY = max.ym;
                let bbox = `${minX},${minY},${maxX},${maxY}`;
                let tileSize = getDynamicTileSize(zoom); // Get dynamic tile size

                let url;

                if (zoom <= 7) {
                    console.log('Layers rendering function called')
                    if (!layerApi) {
                        url = `${__API_URI_3__}/Layer/RenderStateBoundary/${mapObjVal}?zoomLevel=${8}&bbox=${bbox}&width=${tileSize.width}&height=${tileSize.height}&units=${units}`
                    } else {
                        if (params) {
                            url = `${__API_URI_3__}/${layerApi}?zoomLevel=${zoom}&bbox=${bbox}&width=${tileSize.width}&height=${tileSize.height}&units=${units}&${params}`

                        } else {
                            url = `${__API_URI_3__}/${layerApi}?zoomLevel=${zoom}&bbox=${bbox}&width=${tileSize.width}&height=${tileSize.height}&units=${units}&StateAbbreviation=${payload.StateAbbreviation}&Species=${payload.Species}&HuntTypeKey=${payload.HuntTypeKey}`
                        }
                    }
                } else {
                    if (!layerApi) {
                        url = `${__API_URI_3__}/Layer/RenderStateBoundary/${mapObjVal}?zoomLevel=${zoom}&bbox=${bbox}&width=${tileSize.width}&height=${tileSize.height}&units=${units}`
                    } else {
                        if (params) {
                            url = `${__API_URI_3__}/${layerApi}?zoomLevel=${zoom}&bbox=${bbox}&width=${tileSize.width}&height=${tileSize.height}&units=${units}&${params}`
                        }
                        else {
                            url = `${__API_URI_3__}/${layerApi}?zoomLevel=${zoom}&bbox=${bbox}&width=${tileSize.width}&height=${tileSize.height}&units=${units}&StateAbbreviation=${payload.StateAbbreviation}&Species=${payload.Species}&HuntTypeKey=${payload.HuntTypeKey}`
                        }
                    }
                }

                const fetcher = { needsAuth: true, url: url, tile: null, zoom: zoom, id: '', drawOrder: '' };
                fetcher.tile = doc.createElement('img');

                fetcher.tile.onerror = () => {
                    fetcher.tile.style.display = 'none';
                };
                fetcher.tile.style.left = '0px';
                fetcher.tile.style.top = '0px';
                fetcher.tile.style.position = 'absolute';
                fetcher.tile.style.zIndex = '111';
                addOverlayTile(fetcher);
                fetcher.tile.onload = () => {
                    fetcher.tile.style.display = 'block';
                    requestAnimationFrame(() => {
                        setTimeout(() => {
                            let huntMapLoader = store.getState().huntMapLoader
                            if (huntMapLoader) {
                                store.dispatch(stopMapLoading());
                            }
                            callback();
                        }, 1000);
                    });
                };
                return fetcher.tile;
            },
            tileSize: new google.maps.Size(256 * 4 * 2, 256 * 4 * 2),
            // tileSize: getDynamicTileSize(mapInstance.getZoom()), // Dynamically set tile size
            minZoom: 3,
            maxZoom: 18,
            name: mapObjVal ? mapObjVal.StateAbbreviation : 'no name',
            opacity: 1,
            visible: true,
            alt: {
                id: layerData ? layerData.layerId : '',
                name: layerData ? layerData.stateAbbr : '',
                from: 'hunt planner'
            }
        });

        updateOverlay(mapInstance, overlay);
        currentOverlay = overlay;
    }

    function debounce(func, delay) {
        let timer;
        return function () {
            clearTimeout(timer);
            timer = setTimeout(() => func(), delay);
        };
    }

    if (zoomEvent) {
        google.maps.event.removeListener(zoomEvent);
    }

    let loader = () => {
        const hasTileLayers = mapInstance.overlayMapTypes.getArray()
            .some(layer => layer.alt?.from === 'hunt planner');
        if (hasTileLayers) {
            store.dispatch(startMapLoading());
            // Safety net: if no tile fires onload within 1.5s (already cached), stop the spinner.
            setTimeout(() => {
                if (store.getState().huntMapLoader) store.dispatch(stopMapLoading());
            }, 1500);
        }
    }

    zoomEvent = google.maps.event.addListener(mapInstance, 'zoom_changed', debounce(loader, 500));

    createOverlay();
    return overlay;
}

export function multiTileHuntLayersXYZ(mapInstance) {
    let overlay;
    let zoomEvent;

    function createOverlay() {
        if (!mapInstance) {
            console.error("Error: mapInstance is undefined.");
            return;
        }

        // ✅ OpenStreetMap Tile URL

        let xyzTileUrl;

        xyzTileUrl = "https://d17nskp3ikx9h0.cloudfront.net/tiles/USA:usa_govtlandparcels_vpaid/EPSG:3857/png8/default/{z}/{x}/{y}.png"

        // xyzTileUrl = 'https://d17nskp3ikx9h0.cloudfront.net/tiles/DEMS:lidar_hillshade/EPSG:3857/png/default/{z}/{x}/{y}.png'
        // xyzTileUrl = "https://a.tile.openstreetmap.org/{z}/{x}/{y}.png"
        // xyzTileUrl = "https://basemap.nationalmap.gov/arcgis/rest/services/USGSImageryOnly/MapServer/tile/{z}/{y}/{x}"
        // xyzTileUrl = "https://basemap.nationalmap.gov/arcgis/rest/services/USGSTopo/MapServer/tile/{z}/{y}/{x}"
        // xyzTileUrl = "https://a.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png"

        // ✅ Function to get tile bounds
        function getTileBounds(x, y, zoom) {
            const n = Math.pow(2, zoom);
            const lon_w = (x / n) * 360 - 180;
            const lon_e = ((x + 1) / n) * 360 - 180;
            const lat_n_rad = Math.atan(Math.sinh(Math.PI * (1 - 2 * y / n)));
            const lat_s_rad = Math.atan(Math.sinh(Math.PI * (1 - 2 * (y + 1) / n)));
            const lat_n = lat_n_rad * 180 / Math.PI;
            const lat_s = lat_s_rad * 180 / Math.PI;

            return {
                north: lat_n,
                south: lat_s,
                east: lon_e,
                west: lon_w
            };
        }

        class ImageMapType extends google.maps.MVCObject {
            constructor(props) {
                super(props)
                Object.assign(this, props)
            }
        }

        // ✅ Create an XYZ Tile Layer
        overlay = new google.maps.ImageMapType({

            getTileUrl: function (coord, zoom) {
                const tileBounds = getTileBounds(coord.x, coord.y, zoom);
                let tmsY
                // true conversion  &  false means direct
                if (true) {
                    tmsY = (1 << zoom) - 1 - coord.y;
                } else {
                    tmsY = coord.y;
                }
                return xyzTileUrl
                    .replace("{x}", coord.x)
                    .replace("{y}", tmsY)
                    .replace("{z}", zoom);
            },

            tileSize: new google.maps.Size(256, 256),
            name: "Colorado Tiles",
            maxZoom: 18
        });

        // ✅ Ensure mapInstance.overlayMapTypes exists
        if (mapInstance.overlayMapTypes) {
            mapInstance.overlayMapTypes.clear();
            mapInstance.overlayMapTypes.insertAt(0, overlay);
        } else {
            console.error("Error: mapInstance.overlayMapTypes is not available.");
        }
    }

    createOverlay();

    return overlay;
}


export function multiTileHuntLayersXYZTwoLayers(mapInstance) {
    if (!mapInstance) {
        console.error("Error: mapInstance or mapInstance.overlayMapTypes is undefined.");
        return;
    }

    const layers = [
        {
            name: "Lidar Hillshade",
            url: "https://d17nskp3ikx9h0.cloudfront.net/tiles/DEMS:lidar_hillshade/EPSG:3857/png/default/{z}/{x}/{y}.png"
        },
        {
            name: "Public Land",
            url: "https://d17nskp3ikx9h0.cloudfront.net/tiles/USA:usa_govtlandparcels_vpaid/EPSG:3857/png8/default/{z}/{x}/{y}.png"
        }
    ];

    // TMS conversion toggle
    const useTMS = true;

    function getTileBounds(x, y, zoom) {
        const n = Math.pow(2, zoom);
        const lon_w = (x / n) * 360 - 180;
        const lon_e = ((x + 1) / n) * 360 - 180;
        const lat_n_rad = Math.atan(Math.sinh(Math.PI * (1 - 2 * y / n)));
        const lat_s_rad = Math.atan(Math.sinh(Math.PI * (1 - 2 * (y + 1) / n)));
        const lat_n = lat_n_rad * 180 / Math.PI;
        const lat_s = lat_s_rad * 180 / Math.PI;

        return {
            north: lat_n,
            south: lat_s,
            east: lon_e,
            west: lon_w
        };
    }

    class ImageMapType extends google.maps.MVCObject {
        constructor(props) {
            super(props)
            Object.assign(this, props)
        }
    }

    layers.forEach((layerConfig, index) => {
        const overlay = new google.maps.ImageMapType({
            getTileUrl: function (coord, zoom) {
                const tileBounds = getTileBounds(coord.x, coord.y, zoom);
                const tmsY = useTMS ? (1 << zoom) - 1 - coord.y : coord.y;

                return layerConfig.url
                    .replace("{x}", coord.x)
                    .replace("{y}", tmsY)
                    .replace("{z}", zoom);
            },
            tileSize: new google.maps.Size(256, 256),
            name: layerConfig.name,
            maxZoom: 18
        });

        mapInstance.overlayMapTypes.insertAt(index, overlay);
    });
}


export let updateOverlay = (mapInstance, newOverlay) => {
    let overlays = mapInstance.overlayMapTypes.getArray();
    let existingOverlayIndex = overlays.findIndex(layer => layer.alt?.id === newOverlay.alt?.id);

    mapInstance.overlayMapTypes.push(newOverlay);

    if (existingOverlayIndex !== -1) {
        setTimeout(() => {
            let updatedOverlays = mapInstance.overlayMapTypes.getArray();
            let existingOverlay = updatedOverlays[existingOverlayIndex];

            if (existingOverlay && existingOverlay.alt?.id === newOverlay.alt?.id) {
                mapInstance.overlayMapTypes.removeAt(existingOverlayIndex);
            }
        }, 3000);
    }

    let sortedOverlays = mapInstance.overlayMapTypes.getArray().sort((b, a) => {
        return (b.alt?.from === 'hunt planner' ? 1 : 0) - (a.alt?.from === 'hunt planner' ? 1 : 0);
    });

    sortedOverlays.forEach((layer, index) => {
        let currentIndex = mapInstance.overlayMapTypes.getArray().indexOf(layer);
        if (currentIndex !== index) {
            mapInstance.overlayMapTypes.removeAt(currentIndex);
            mapInstance.overlayMapTypes.insertAt(index, layer);
        }
    });
};



export function removeZoomEVent(mapInstance) {
    if (zoomEVent) {
        google.maps.event.removeListener(zoomEVent);
        google.maps.event.clearListeners(mapInstance, 'zoom_changed');
        zoomEVent = null;
    } else {
        console.log('No zoom event listener found.');
    }
}

export function removeZoomEvent() {
    if (zoomEvent) {
        google.maps.event.removeListener(zoomEvent);
        zoomEvent = null;
    }
}

function getDynamicTileSize(zoom) {
    if (zoom <= 6) {
        // return new google.maps.Size(256, 256); // Large tiles for lower zoom levels
        return new google.maps.Size(256 * 4 * 2, 256 * 4 * 2); // Small tiles for higher zoom levels
    } else {
        return new google.maps.Size(256 * 4 * 2, 256 * 4 * 2); // Small tiles for higher zoom levels
    }
}

export let removeLayers = (mapInstance) => {
    for (let i = mapInstance.overlayMapTypes.getLength() - 1; i >= 0; i--) {
        let overlay = mapInstance.overlayMapTypes.getAt(i);
        if (overlay && overlay.alt && overlay.alt?.from === 'hunt planner') {
            mapInstance.overlayMapTypes.removeAt(i);
        }
    }
};